import styled from 'styled-components';

export const StyledConsentCheckbox = styled.div`
  .consent-privacytext {
    margin-top: -3px !important;
    font-weight: 400 !important;
    margin-bottom: 36px !important;
    padding-left: 30px !important;
    a {
      text-decoration: underline !important;
      font-weight: 400 !important;
    }
  }
`;
